<template>
<div class="page page_iteminfo page_co">
    <van-tabs v-model="active" swipe-threshold="6">
        <van-tab title="已审核" :name="0"></van-tab>
        <van-tab title="待审核" :name="1"></van-tab>
    </van-tabs>
    <!-- 已审匠人 -->
    <div class="jiangren" v-if="active == 0">
        <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="getData">
			<div class="con" v-for="(item,index) in tradesmanList" :key="index">
				<div class="con_info">
					<div class="thumb" v-if="item.tradesman">
						<img :src="item.tradesman.thumb ? ( $publicData.withHttpStart(item.tradesman.thumb) ? item.tradesman.thumb : imageUrl+item.tradesman.thumb) : $publicData.defaultTouxiang" alt="" class="">
					</div>
					<div class="name" v-if="item.tradesman">{{ item.tradesman.nickname }}</div>
				</div>
			</div>
        </van-list>
    </div>
	<!-- 待审匠人 -->
	<div class="jiangren" v-if="active == 1">
        <van-list v-model="loading_pend" :finished="finished_pend" :immediate-check="false" finished-text="没有更多了" @load="getDataPend">
			<div class="con" v-for="(item,index) in pendTradesmanList" :key="index">
				<div class="con_info">
					<div class="thumb" v-if="item.tradesman">
						<img :src="item.tradesman.thumb ? ($publicData.withHttpStart(item.tradesman.thumb) ? item.tradesman.thumb : imageUrl+item.tradesman.thumb) : $publicData.defaultTouxiang" alt="" class="">
					</div>
					<div class="name" v-if="item.tradesman">{{ item.tradesman.nickname }}</div>
				</div>
				<div class="guanzhu guanzhu_no" @click="clickPendTradesman(item.tradesman)">审核</div>
			</div>
        </van-list>
    </div>
	<!-- 审核弹层 -->
	<van-dialog v-model="show" title="审核" show-cancel-button @confirm="bindPend">
		<div class="pend">
			<van-radio-group v-model="radio">
				<van-radio :name="0">认证中</van-radio>
				<van-radio :name="1">认证通过</van-radio>
				<van-radio :name="2">未通过</van-radio>
			</van-radio-group>
		</div>
	</van-dialog>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: '',
            pages: {
                page: 1,
                size: 10
            },
            tradesmanList: [], // 已审
            pendTradesmanList: [], // 待审
			loading: true,
			finished: false,
			active: 0,
			pendPages:{
				page: 1,
				size: 10
			},
			loading_pend: true,
			finished_pend: false,
			show: false, //审核弹层
			radio: 0 ,// 状态0认证中1认证通过2未通过
			selectTradesman: null // 欲审核匠人信息
        };
    },
    created: function () {

    },
    mounted: function () {
        console.log('mounted')
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '匠人列表',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
					this.getData()
					this.getDataPend()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
				this.getData()
				this.getDataPend()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
			this.getData()
			this.getDataPend()
        }

    },
    methods: {
        // 获取列表
        getData() {
            var params = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.park.tradelist(params).then(res => {
                if (res.code == 200) {
					var list = res.result
					if(list.length != 0){
						this.tradesmanList = this.tradesmanList.concat(list)
						this.pages.page++
						this.loading = false
					}else{
						this.finished = true
					}
                }else{
					this.finished = true
				}
            })
		},
		// 获取待审匠人
		getDataPend(){
			var params = {
                token: this.token,
                page: this.pendPages.page,
                size: this.pendPages.size
            }
            this.$api.park.pendTradelist(params).then(res => {
                if (res.code == 200) {
					var list = res.result
					if(list.length != 0){
						this.pendTradesmanList = this.pendTradesmanList.concat(list)
						this.pendPages.page++
						this.loading_pend = false
					}else{
						this.finished_pend = true
					}
                }else{
					this.finished_pend = true
				}
            })
		},
		// 展示审核弹层
		clickPendTradesman(tradsman){
			this.selectTradesman = tradsman
			this.show = true
		},
		// 审核
		bindPend(){
			var that = this
			var params = {
				token: that.token,
				status: that.radio,
				trades_uuid: that.selectTradesman.uuid,
				tradesman_id: that.selectTradesman.id
			}
			that.$api.park.tradereview(params).then(res=>{
				if(res.code == 200){
					that.$toast(res.message)
					that.active = 1
					that.pendPages.page = 1
					that.loading_pend = true
					that.finished_pend = false
					that.pendTradesmanList = []
					that.getDataPend()
				}else{
					that.$toast(res.message)
				}
			})
		}
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
